// export const DsfMonacoCustom = Vue.defineLazyComponent(()=>require('./monacoEditorCustom.vue'));
export const DsfMonacoCustom = Vue.defineAsyncComponent(() =>
  import(/*webpackChunkName: "platform_pc_monacoCustom"*/ "./monacoEditorCustom.vue")
);
